import { IServerSideGetRowsRequest } from 'ag-grid-enterprise';
import { convertAgGridSort } from '@app/core/http/http-resource-helper';
import {
  ComplexSearchRequest,
  SearchRequest,
} from '@app/shared/search/interfaces/search-request';

export const getSortParams = (request: IServerSideGetRowsRequest) => {
  const sort = request.sortModel.map((sort) => convertAgGridSort(sort));

  return sort.length ? sort[0] : null;
};

export const convertToSafePostComplexSearchRequest = (
  filter: ComplexSearchRequest,
) => {
  if (!filter) {
    return;
  }

  const convertedFilters: SearchRequest[] = [];
  const convertedOptionalFilters: SearchRequest[] = [];

  filter.filters?.map((filter) => {
    convertedFilters.push({
      operand: filter.operand,
      filterParameters: filter.filterParameters.map((filterParameter) => ({
        ...filterParameter,
        value: filterParameter.value.toString(),
      })),
    });
  });

  filter.optionalFilters?.map((filter) => {
    convertedOptionalFilters.push({
      operand: filter.operand,
      filterParameters: filter.filterParameters.map((filterParameter) => ({
        ...filterParameter,
        value: filterParameter.value.toString(),
      })),
    });
  });

  return {
    filters: convertedFilters,
    optionalFilters: convertedOptionalFilters,
  } as ComplexSearchRequest;
};
